<div
	[ngSwitch]="colorType"
	class="row gx-0 flex-column"
>
	<!-- HUE -->
	<ng-container
		*ngSwitchCase="colorTypEnum.HUE"
		[ngTemplateOutlet]="colorPickerHue"
	></ng-container>

	<!-- PREVIEW -->
	<ng-container
		*ngSwitchCase="colorTypEnum.PREVIEW"
		[ngTemplateOutlet]="colorPickerPreview"
		[ngTemplateOutletContext]="{'color': selectedColor}"
	></ng-container>

	<!-- SLIDER -->
	<ng-container
		*ngSwitchCase="colorTypEnum.SLIDER"
		[ngTemplateOutlet]="colorPickerSlider"
	></ng-container>

	<!-- SWATCHES -->
	<ng-container
		*ngSwitchCase="colorTypEnum.SWATCHES"
		[ngTemplateOutlet]="colorPickerSwatches"
	></ng-container>
</div>

<!-- ######################### TEMPLATES ######################### -->
<!-- HUE -->
<ng-template #colorPickerHue>
	<color-hue-picker
		class="d-block"
		[color]="selectedColor?.hsl"
		(onChange)="onHueColorChange($event)"
		(onSwatchHover)="hoverColor = $event?.color"
		[width]="'100%'"
	></color-hue-picker>
</ng-template>

<!-- PREVIEW -->
<ng-template
	#colorPickerPreview
	let-color="color"
>
	<div class="row gx-0 align-items-center">
		<div
			class="color-preview-box me-3 mb-3"
			[ngStyle]="{
				'background-color': colorIsSet ? color?.hex : 'initial'
			}"
			[ngClass]="{
				'no-color': !colorIsSet
			}"
		></div>

		<ng-container
			[ngTemplateOutlet]="colorDetails"
			[ngTemplateOutletContext]="{'color': color}"
		></ng-container>
	</div>
</ng-template>

<!-- SLIDER -->
<ng-template #colorPickerSlider>
	<ng-container
		[ngTemplateOutlet]="colorPickerHue"
	></ng-container>
	 <div class="row g-0 mt-2 flex-nowrap colorSliderSwatchWrapper">
		<color-slider-swatch
			*ngFor="let swatchItem of swatchList; let idx=index; let first=first; let last=last"
			class="col"
			[active]="swatchItem.isActive"
			[hsl]="swatchItem.hsla"
			[first]="first"
			[last]="last"
			[offset]="swatchItem.offset"
			(onClick)="onSliderSwatchColorSelect(idx)"
			(mouseenter)="setSliderSwatchHoverColor(idx)"
			(mouseleave)="setSliderSwatchHoverColor()"
			[ngbTooltip]="hoverColorTooltip"
			[openDelay]="300"
		></color-slider-swatch>
	</div>


</ng-template>

<!-- SWATCHES -->
<ng-template #colorPickerSwatches>
	<color-swatches
		class="d-inline-block w-100 text-center"
		[mode]="colorModeEnum.HSL"
		[color]="selectedColor?.hsl"
		[zDepth]="0"
		[colors]="colorSwatchesConfig?.presetColors"
		[background]="'transparent'"
		[width]="'100%'"
		[height]="'auto'"
		(onChangeComplete)="onSwatchesItemColorSelect($event)"
		(onSwatchHover)="hoverColor = $event?.color"
	></color-swatches>
</ng-template>

<!-- COLOR DETAILS -->
<ng-template
	#colorDetails
	let-color="color"
>
	<div class="d-flex flex-column fw-regular fs-sx align-items-start">

		<div class="row mx-0">
			<span class="label me-2">HSL</span>
			<span class="value select-text">{{ getColorStrings( color ).hsl }}</span>
		</div>

		<div class="row mx-0">
			<span class="label me-2">RGB</span>
			<span class="value select-text">{{ getColorStrings( color ).rgb }}</span>
		</div>

		<div class="row mx-0">
			<span class="label me-2">HEX</span>
			<span class="value select-text">{{ getColorStrings( color ).hex | uppercase }}</span>
		</div>
	</div>
</ng-template>

<!-- HOVER COLOR TOOLTIP -->
<ng-template #hoverColorTooltip>
	<ng-container
		[ngTemplateOutlet]="colorDetails"
		[ngTemplateOutletContext]="{'color': hoverColor}"
	></ng-container>
</ng-template>

<!-- SELECTED COLOR TOOLTIP -->
<ng-template #selectedColorTooltip>
	<ng-container
		[ngTemplateOutlet]="colorPickerPreview"
		[ngTemplateOutletContext]="{'color': selectedColor}"
	></ng-container>
</ng-template>
